module.exports = __webpack_public_path__ + "static/media/AdmisionesTotales.22288dda.svg";